import { useEffect, useState } from "react";
import { endpoints, fmtTime } from "@/lib/api";
import { BadgeCheck, X } from "lucide-react";

export default function CPRegistration() {
  const [data, setData] = useState(null);
  useEffect(() => {
    endpoints.cpRegistration().then(setData);
  }, []);

  if (!data) return <div className="px-12 py-14 text-zinc-500">Loading…</div>;

  return (
    <div className="max-w-[1000px] px-12 py-14" data-testid="page-cp">
      <div className="tx-overline mb-2">Module M5</div>
      <h1 className="font-heading font-black text-4xl mb-2">Channel Partner Registration</h1>
      <p className="text-zinc-600 text-[14px] max-w-2xl mb-8">
        The ISV's AWS Channel Partner status plus the standing VARs that have
        delegated AMMP access to Private Offer Autopilot — the moat that eliminates onboarding
        latency for new CPPOs.
      </p>

      <div className="border border-zinc-200 bg-zinc-50 p-6 mb-8">
        <div className="flex items-start justify-between">
          <div>
            <div className="tx-overline mb-1">ISV</div>
            <div className="font-heading text-2xl text-zinc-900 mb-1">
              {data.isv.company}
            </div>
            <div className="font-mono text-[11px] text-zinc-500">{data.isv.cp_id}</div>
          </div>
          <div className="flex items-center gap-2 text-emerald-600 text-[12px] font-mono">
            <BadgeCheck className="w-4 h-4" /> {data.isv.status}
          </div>
        </div>
        <div className="grid grid-cols-2 gap-x-8 gap-y-2 mt-6 text-[13px]">
          <div>
            <span className="tx-overline">Registered since</span>
            <div className="font-mono text-zinc-900 mt-1">
              {fmtTime(data.isv.registered_since)}
            </div>
          </div>
          <div>
            <span className="tx-overline">Authorized regions</span>
            <div className="font-mono text-zinc-900 mt-1">
              {data.isv.regions.join(", ")}
            </div>
          </div>
        </div>
      </div>

      <div className="tx-overline mb-3">Standing VARs (delegated AMMP)</div>
      <div className="border border-zinc-200 bg-zinc-50 divide-y divide-zinc-200">
        {data.standing_vars.map((v) => (
          <div key={v.var} className="p-5 flex items-center justify-between">
            <div>
              <div className="font-heading text-lg">{v.var}</div>
              <div className="font-mono text-[11px] text-zinc-500 mt-0.5">
                {v.delegated_ammp ? `Delegated since ${fmtTime(v.since)}` : "No delegation"}
              </div>
            </div>
            {v.delegated_ammp ? (
              <span className="inline-flex items-center gap-1.5 text-emerald-600 text-[11px] font-mono">
                <BadgeCheck className="w-3.5 h-3.5" /> DELEGATED
              </span>
            ) : (
              <span className="inline-flex items-center gap-1.5 text-zinc-500 text-[11px] font-mono">
                <X className="w-3.5 h-3.5" /> UNDELEGATED
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
